import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import './styles.less';

function mapStateToProps({modules, destination}) {
    return {
        dynamicQuestions: destination.dynamicQuestions,
        moduleHeading: modules.pageHeadings.faq || '',
        showNewHeadings: modules.pageHeadings.showNewHeadings,
    };
}

export class DynamicQuestionComponent extends PureComponent {
    render() {
        const {
            dynamicQuestions = [],
            showNewHeadings,
            moduleHeading,
        } = this.props;

        if (!dynamicQuestions || !dynamicQuestions.length) {
            return null;
        }

        const questions = dynamicQuestions
            .filter(({heading, intro}) => heading && intro)
            .map(({heading, intro, answer, outro}, i) => {
                return (
                    <div
                        className={'col-md-12'}
                        key={`q${i}`}
                        itemScope
                        itemProp={'mainEntity'}
                        itemType={'https://schema.org/Question'}
                    >
                        <h3 itemProp={'name'}>{heading}</h3>
                        <div
                            itemScope
                            itemProp={'acceptedAnswer'}
                            itemType={'https://schema.org/Answer'}
                        >
                            <div itemProp={'text'}>
                                <p>{intro}</p>
                                {answer ? (
                                    <ul className={'dynamic-answers'}>
                                        {answer.map((item, j) => (
                                            <li key={`q${i}a${j}`}> {item} </li>
                                        ))}
                                    </ul>
                                ) : null}
                                {outro ? <p>{outro}</p> : null}
                            </div>
                        </div>
                    </div>
                );
            });

        return (
            <div
                className={'container module dynamic-questions'}
                itemScope
                itemType={'https://schema.org/FAQPage'}
            >
                {showNewHeadings && (
                    <h2 className="page-heading">{moduleHeading}</h2>
                )}
                <div className={'row'}>{questions}</div>
            </div>
        );
    }
}

export const DynamicQuestion = connect(mapStateToProps)(
    DynamicQuestionComponent
);

DynamicQuestion.displayName = 'DynamicQuestion';

export default DynamicQuestion;
